export enum WallboxCustomVisibilityCheck {
  DATA_EXPORT = 'DATA_EXPORT',
  AUTHENTICATION = 'AUTHENTICATION',
}
